import React, {ReactNode} from 'react';
import {isString, over} from 'lodash';
import {modal} from './modal';
import {Button, Flex} from 'components';

export const dialog = (props: Props) => modal(DialogPopup, props);

interface Props {
  title?: string;
  content?: ReactNode;
  confirm: {
    title?: string,
    callback: () => void;
  }
}

export const DialogPopup = ({title, content, confirm, popup}: Props) => {
  return (
    <>
      {title && <h4>{title}</h4>}
      {isString(content) ? <p>{content}</p> : content}
      <Flex className={['spacing', 'right']}>
        <Button
          onClick={popup.close}
          className="subtle"
          children="Cancel"
        />
        <Button
          icon="check"
          className="primary"
          children={confirm.title ?? 'Confirm'}
          onClick={over(confirm.callback, popup.close)}
        />
      </Flex>
    </>
  );
};
